import { track } from "./analytics";

// Single source of truth for the "Follow on Spotify" action — always opens the
// official Spotify ARTIST profile (never a specific track/album) and fires the
// existing spotify_artist_follow_cta_clicked analytics event.
export function followOnSpotify(spotifyArtistUrl) {
  if (!spotifyArtistUrl) return;
  track("spotify_artist_follow_cta_clicked");
  window.open(spotifyArtistUrl, "_blank", "noopener");
}
